module.exports = __webpack_public_path__ + "img/edge.bd39ae5b.png";